module.exports = __webpack_public_path__ + "assets/i18n/it.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/it.json
// module id = 1209
// module chunks = 0